import type {
  AccountResponse,
  InfoCards,
} from "../../account-information/types/ShippingAccount.types";

const formatArrayValue = (value?: string[]): string => {
  return value?.length ? value.join(", ") : "-";
};

const formatBooleanValue = (value?: boolean): string => {
  const YES = "Yes";
  const NO = "No";
  return value ? YES : NO;
};

export const getInfoCards = (
  data: AccountResponse | null,
): InfoCards | null => {
  if (!data) return null;
  const additionalContactInfo = data?.additionalContactInformations?.[0] ?? {};

  const isAdditionalContactInfoNotEmpty =
    additionalContactInfo && Object.keys(additionalContactInfo).length > 0;

  return {
    overview: {
      heading: "Overview",
      items: [
        {
          label: "Country",
          value: data.country || "-",
        },
        {
          label: "Customer Type",
          value: data.customerType || "-",
        },
        {
          label: "Services Requested",
          value: formatArrayValue(data.servicesRequested),
        },
        {
          label: "Product Categories",
          value: formatArrayValue(data.productCategories),
        },
      ],
    },

    shippingDetails: {
      heading: "Shipping details",
      items: [
        {
          label: "Average number of shipments per month",
          value: String(data.averageOrdersPerMonth || "-"),
        },
        {
          label: "Where do you ship?",
          value: data.isInternationalShipping
            ? "International (outside the country)"
            : "Domestic (within the country)",
        },
        {
          label: "International destinations",
          value: formatArrayValue(data.destinationCountries),
        },
        {
          label: "3PL for fulfillment",
          value: formatBooleanValue(data.isUsing3PL),
        },
        {
          label: "3PL account number",
          value: data.threePLAccountNumber || "-",
        },
      ],
    },
    companyInformation: {
      heading: "Company Information",
      items: [
        {
          label: "Company Name",
          value: data.companyName || "-",
        },
        {
          label: "Company registration no.",
          value: data.companyRegistrationNumber || "-",
        },
        {
          label: "Company Address",
          value: data.companyAddress || "-",
        },
        {
          label: "Postal Code",
          value: data.postalCode || "-",
        },
        {
          label: "City",
          value: data.city || "-",
        },
        {
          label: "State",
          value: data.state || "-",
        },
        {
          label: "Country",
          value: data.companyCountry || "-",
        },
      ],
    },
    contactInformation: {
      heading: "Contact Information",
      items: [
        {
          label: "Contact Person",
          value: `${data.firstName || ""} ${data.lastName || ""}`.trim() || "-",
        },
        {
          label: "Company Email",
          value: data.workEmail || "-",
        },
        {
          label: "Phone Number",
          value: data.phoneNumber || "-",
        },
        {
          label: "Job title",
          value: data.jobTitle || "-",
        },
      ],
    },
    ...(isAdditionalContactInfoNotEmpty && {
      additionalContactInformation: {
        heading: "Billing Contact Information",
        items: [
          {
            label: "Contact Person",
            value:
              `${additionalContactInfo.firstName || ""} ${additionalContactInfo.lastName || ""}`.trim() ||
              "-",
          },
          {
            label: "Company Email",
            value: additionalContactInfo.workEmail || "-",
          },
          {
            label: "Phone Number",
            value: additionalContactInfo.phoneNumber || "-",
          },
          {
            label: "Job title",
            value: additionalContactInfo.jobTitle || "-",
          },
        ],
      },
    }),
  };
};
